import { useEffect, useState } from 'react';
// Lightweight process-wide store for the selected project's analytical-layer
// readiness. The colour-by dropdowns live OUTSIDE the ProjectDataProvider
// subtree, so a plain subscribable store is simpler (and safer) than threading
// a prop through every dialog wrapper. Single map view at a time, so a module
// singleton is sufficient; MapViewer publishes on structure changes.
let current = {};
const listeners = new Set();
// Publish the latest readiness. Reference-stable between calls so the read hook
// doesn't re-render unless the value actually changed.
export const setLayerReadiness = (state) => {
    current = state;
    listeners.forEach(notify => notify());
};
export const getLayerReadiness = () => current;
// Subscribe a component to readiness updates. Returns the current state; the
// no-provider default ({}) means "everything ready", so dialogs rendered before
// any structure loads never falsely grey their options.
export const useLayerReadiness = () => {
    const [state, setState] = useState(getLayerReadiness);
    useEffect(() => {
        const notify = () => setState(getLayerReadiness());
        listeners.add(notify);
        notify(); // resync in case it changed between initial read and subscribe
        return () => { listeners.delete(notify); };
    }, []);
    return state;
};
